import { useState, useEffect } from 'react';
import { AlertCircle, Loader2 } from 'lucide-react';
import { fetchLibraries } from '../../api/videoLibrariesApi';

export default function LibrariesList({ libraryId, setLibraryId }) {
  const [libraries, setLibraries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getLibraries = async () => {
      try {
        setLoading(true);
        const data = await fetchLibraries();
        setLibraries(data);
        setError(null);
      } catch (err) {
        setError(err.message || 'Failed to fetch libraries');
      } finally {
        setLoading(false);
      }
    };

    getLibraries();
  }, []);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center p-8 text-gray-700">
        <Loader2 className="h-8 w-8 animate-spin mb-2" />
        <p>Loading libraries...</p>
      </div>
    );
  }

  console.log("libary id :", libraryId)

  if (error) {
    return (
      <div className="p-6 bg-red-50 rounded-lg border border-red-200">
        <div className="flex items-center mb-4">
          <AlertCircle className="h-6 w-6 text-red-500 mr-2" />
          <h2 className="text-lg font-semibold text-red-700">Error</h2>
        </div>
        <p className="text-red-600">{error}</p>
        <p className="mt-2 text-gray-700">Please check your API connection and try again.</p>
      </div>
    );
  }

  if (libraries.length === 0) {
    return (
      <div className="p-6 bg-gray-50 rounded-lg border border-gray-200 text-center">
        <p className="text-gray-600">No libraries available.</p>
      </div>
    );
  }

  return (
    <div className="w-full max-w-md mx-auto">
      <label
        htmlFor="libraries"
        className="block mb-2 text-sm font-medium text-gray-700"
      >
        Select a Library
      </label>
      <select
        id="libraries"
        className="block w-full rounded-md border border-gray-300 bg-white py-2 px-3 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
        value={libraryId || ''}
        onChange={(e) => setLibraryId(e.target.value)}
      >
        <option value="" disabled>
          -- Choose a library --
        </option>
        {libraries.map((library) => (
          <option key={library.id} value={library.id} 
           selected =  {library.id == libraryId}
          >
            {library.title} (ID: {library.bunney_library_id})
          </option>
        ))}
      </select>
    </div>
  );
}
